import React from 'react'
import HomePage from '../Components/HomePage/HomePage'
const Home = () => {
  return (
 <HomePage/>
  )
}

export default Home